import { render, staticRenderFns } from "./SeniorityCard.vue?vue&type=template&id=19735a24&"
import script from "./SeniorityCard.vue?vue&type=script&lang=js&"
export * from "./SeniorityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports